class Voter {
  id = 0

  name = ''

  surname = ''

  email = ''

  mobile = ''

  active = true

  tags = []

  authorizers = []

  weight = 1.0

  created_at = null

  updated_at = null

  emails_sent = 0

  pin_count = 0

  constructor(options = {}) {
    Object.assign(this, options)
  }

  // let voter = (new Voter).fill({ name: "Acme d.o.o.", weight: 1.00 });
  fill(options) {
    return Object.assign(this, options)
  }
}

export default Voter
